import React from 'react';
import { LinearProgress, makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  root: { minWidth: 160, maxWidth: 280, width: '100%' },
  heading: {
    display: 'flex',
    justifyContent: 'space-between',
    gap: theme.spacing(1),
    marginBottom: theme.spacing(0.5),
  },
  failed: {
    '& .MuiLinearProgress-bar': { backgroundColor: theme.palette.error.main },
  },
  stale: { fontSize: '0.75rem', marginTop: theme.spacing(0.5) },
}));
export default function CalculationProgress({ status }) {
  const classes = useStyles();
  if (!status) return null;
  const percent =
    typeof status.percent === 'number' && Number.isFinite(status.percent)
      ? Math.min(100, Math.max(0, status.percent))
      : null;
  // Older terminal runs have no counters. Missing history is not active work.
  const terminal = ['failed', 'succeeded'].includes(status.runStatus);
  const showBar = percent !== null || !terminal;
  return (
    <div className={classes.root}>
      <div className={classes.heading} role="status" aria-live="polite">
        <span>{status.label}</span>
        {percent !== null && <span>{percent}%</span>}
      </div>
      {showBar && <LinearProgress
        aria-label={status.label}
        variant={percent === null ? 'indeterminate' : 'determinate'}
        value={percent === null ? undefined : percent}
        className={status.runStatus === 'failed' ? classes.failed : undefined}
      />}
      {status.stale && (
        <div className={classes.stale}>Last confirmed; status unavailable</div>
      )}
    </div>
  );
}
